import React from "react";

const SidePopUp = ({ isOpen, toggle, children }) => {
   if (!isOpen) return null; 

  return (
    <>
      <div
        className={`sidepopup-backdrop ${isOpen ? "show" : ""}`}
        onClick={toggle}
      />
      <div className={`sidepopup-panel ${isOpen ? "open" : ""}`}>
        <div className="sidepopup-body">
          <button className="sidepopup-close" onClick={toggle}>
            <i className="bx bx-x-circle font-size-18"></i>
          </button>
          {children}
        </div>
      </div>
    </>
  );
};

export default SidePopUp;
